export * from './kanzi-dynamic-component.component';
